import { Button, Card, Input, Switch, Table } from "antd";

import Loading from "../common/Loading";
import styles from "./index.module.less";

import { useClientParkingAvailabilityList } from "./index.hook.tsx";

const ClientParkingAvailabilityList = () => {
  const config = useClientParkingAvailabilityList();

  return (
    <Card
      className={`gx-card card--height`}
      title={
        <div className={styles["card-container"]}>
          <div>
            <span className="card-title-style">Client Parking Availability</span>
            <Switch className="gx-ml-4" checkedChildren="Auto Refresh" unCheckedChildren="Auto Refresh" checked={config.autoRefresh} onChange={config.handleAutoRefresh}></Switch>
            <Button onClick={config.handleRefreshList} className={`button-gradiant gx-mb-0 gx-ml-4`} loading={config.loading}>
              Refresh
            </Button>
          </div>
          <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} onSearch={config.handleChangeSearch} onChange={(e) => config.handleChangeSearch(e.target.value)} value={config.searchedText} />
        </div>
      }
    >
      {config.loading ? <Loading /> : <>{config.loading ? <Loading /> : <Table className="gx-table-responsive" size="small" columns={config.columns} dataSource={config.filteredData ?? []} pagination={config.pagination} onChange={config.handleChangePagination} bordered rowKey={(record) => record.sr_no} />}</>}
    </Card>
  );
};

export default ClientParkingAvailabilityList;
